import { HTMLAttributes } from "react";
import { setFallbackImage } from "./imageWithFallback.shared";

export type ImageFallbackType =
  | "product-badge"
  | "product-hero"
  | "supplier-badge"
  | "supplier-hero";

interface ImageWithFallbackProps extends HTMLAttributes<HTMLImageElement> {
  img: string | null | undefined;
  fallback: ImageFallbackType;
}

export const ImageWithFallback = (props: ImageWithFallbackProps) => {
  const { img, fallback, ...imgProps } = props;
  const src = setFallbackImage({ img, fallback });
  if (src) return <img src={src} {...imgProps} className={props.className} />;
};
